module.exports = __webpack_public_path__ + "static/media/go-ahead-in-the-rain.badc68cf.jpg";